import { makeAutoObservable } from "mobx";
import { PPromotionInstance } from "./PPromotionInstance";
export class PPromotionScheme {
    constructor(params) {
        this.domain = params.domain;
        this.localizationProvider = params.localizationProvider;
        this.restaurant = params.restaurant;
        this.coupon = params.coupon;
        makeAutoObservable(this);
    }
    get couponState() {
        return this.coupon.state;
    }
    get promotionTypes() {
        if (this.coupon.type === "Enabled") {
            return this.restaurant.promotionTypes.union(this.coupon.couponPromotions);
        }
        return this.restaurant.promotionTypes;
    }
    get promotionInstances() {
        return this.domain.promotionInstances.map((promotionInstance) => new PPromotionInstance({
            localizationProvider: this.localizationProvider,
            domain: promotionInstance,
            promotionType: this.promotionTypes.get(promotionInstance.promotionType.id),
        })).raw;
    }
}
